// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"152":"notification-detail","602":"notification","966":"login"}[chunkId] || chunkId) + "." + {"152":"ffe23a58","362":"9a3ef5fd","515":"c606e6c5","602":"cafd1e68","966":"ef923819"}[chunkId] + ".js";
};